import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-center text-xl font-semibold text-gray-500 dark:text-white" }
const _hoisted_2 = {
  key: 0,
  class: "text-gray-500"
}
const _hoisted_3 = { class: "text-md text-center font-medium text-gray-400 dark:text-gray-500" }
const _hoisted_4 = { class: "single-chart" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  class: "circle-bg",
  d: "M18 2.0845\n          a 15.9155 15.9155 0 0 1 0 31.831\n          a 15.9155 15.9155 0 0 1 0 -31.831"
}, null, -1)
const _hoisted_6 = ["stroke-dasharray"]
const _hoisted_7 = {
  x: "0",
  y: "11",
  width: "100%",
  height: "100%"
}
const _hoisted_8 = { class: "percentage text-center" }
const _hoisted_9 = { class: "font-medium text-gray-600 dark:text-white" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "percentage-text text-gray-300 dark:text-gray-400" }, "vol", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'DoughtnutChart',
  props: {
  value: {
    type: Number
  },
  title: {
    type: String
  },
  city: {
    type: String
  },
  color: {
    type: String
  }
},
  setup(__props) {


// define component proprs



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, [
      (__props.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "#"))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(__props.title), 1)
    ]),
    _createElementVNode("h4", _hoisted_3, _toDisplayString(__props.city), 1),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock("svg", {
        viewBox: "0 0 36 36",
        class: _normalizeClass(["circular-chart", __props.color])
      }, [
        _hoisted_5,
        _createElementVNode("path", {
          class: "circle",
          "stroke-dasharray": __props.value + ', 100',
          d: "M18 2.0845\n          a 15.9155 15.9155 0 0 1 0 31.831\n          a 15.9155 15.9155 0 0 1 0 -31.831"
        }, null, 8, _hoisted_6),
        (_openBlock(), _createElementBlock("foreignObject", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(__props.value) + "%", 1),
            _hoisted_10
          ])
        ]))
      ], 2))
    ])
  ]))
}
}

})